/*
 * Copyright (c) 2026. Orion Analytics. All Rights Reserved
 */

/*
 * Copyright (c) 2026. Orion Analytics
 */

import NAV from "./nav";
import Carousel from "./carousel";

import PriceScroller from "../components/pricescroll_ver_2";
import TrendingNewsScroller from "../components/newsscroll";

import HomeHero from "../components/home/HomeHero";
import HomeMarketPulse from "../components/home/HomeMarketPulse";
import AnalyticsSection from "../components/home/AnalyticsSection";
import ProductSection from "../components/home/ProductSection";
import AudienceSection from "../components/home/AudienceSection";
import StatsSection from "../components/home/StatsSection";
import CTASection from "../components/home/CTASection";
import LiveMarketOverview from "../components/marketsnap";
import AudienceBanner from "../components/home/AudienceBanner";
import PartnerWall from "../components/home/PartnerWall";
import HomeUpdatesHub from "../components/home/HomeUpdatesHub";
import VideoModal from "../components/ui/video";
import React, {useState} from "react";
import PlatformTourWidget from "../components/home/PlatformTourWidget";

export default function HomePageV2() {
  const [showVideo, setShowVideo] = useState(false);
  const [firstTimeOpen, setFirstTimeOpen] = useState(true);

  const handleOpenVideo = () => setShowVideo(true);
  const handleCloseVideo = () => setShowVideo(false);

    return (

        <div className="min-h-screen bg-slate-100">

            <div className="bg-slate-900">

                <NAV activetag="home"/>
                <HomeHero />

            </div>

            <PriceScroller />
            <TrendingNewsScroller />
        <LiveMarketOverview/>

            <div className="max-w-7xl mx-auto px-6 py-8">
                <HomeUpdatesHub />
                <PlatformTourWidget/>
                <HomeMarketPulse />

                <AnalyticsSection />

                <ProductSection />
                <section>
                    <AudienceBanner/>
                    <AudienceSection />
                </section>
                <StatsSection />
                <PartnerWall/>
                <CTASection />

            </div>

        </div>
    );
}